"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const RangeSlider_1 = __importDefault(require("src/components/slider/RangeSlider"));
const Slider = ({ isAllowToUpdate, objective, dataCy }) => {
    const { isUsingWeight } = objective;
    const [weightValue, setWeightValue] = (0, react_1.useState)(objective?.weight);
    const handleChangeWeightInput = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.handleChangeWeightInput);
    const onChangeSlider = (value) => {
        setWeightValue(value);
    };
    (0, react_1.useEffect)(() => {
        handleChangeWeightInput(objective?.id, weightValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objective?.id, weightValue]);
    return (react_1.default.createElement("div", { className: "flex items-center ml-[8px]", "data-cy": dataCy }, isAllowToUpdate && isUsingWeight && (react_1.default.createElement(RangeSlider_1.default, { handleChange: onChangeSlider, value: weightValue, min: 0, max: 100, className: "w-full" }))));
};
exports.default = Slider;
